import { Routes, Route, Navigate, Link, useNavigate, useLocation } from 'react-router-dom'
import { auth } from './api/client'
import LoginPage from './pages/LoginPage'
import DashboardPage from './pages/DashboardPage'
import DiscoverPage from './pages/DiscoverPage'
import ProspectsPage from './pages/ProspectsPage'
import ProspectDetailPage from './pages/ProspectDetailPage'
import LeadsPage from './pages/LeadsPage'
import ReportsPage from './pages/ReportsPage'
import TicklersPage from './pages/TicklersPage'
import EmailLogsPage from './pages/EmailLogsPage'
import SettingsEmailPage from './pages/SettingsEmailPage'
import AdminAIConfigPage from './pages/AdminAIConfigPage'
import AdminSearchConfigPage from './pages/AdminSearchConfigPage'
import SubscriptionPreferencePage from './pages/SubscriptionPreferencePage'

function RequireAuth({ children }: { children: JSX.Element }) {
    const loc = useLocation()
    if (!auth.token()) return <Navigate to="/login" state={{ from: loc }} replace />
    return children
}

function NavBar() {
    const user = auth.user()
    const nav = useNavigate()
    if (!user) return null

    return (
        <nav className="topnav">
            <div className="topnav-brand">SalesAgent</div>
            <div className="topnav-links">
                <Link to="/dashboard">Dashboard</Link>
                <Link to="/discover">Discover</Link>
                <Link to="/prospects">Prospects</Link>
                <Link to="/leads">Leads</Link>
                <Link to="/reports">Reports</Link>
                <Link to="/ticklers">Ticklers</Link>
                <Link to="/email-logs">Emails</Link>
            </div>
            <div className="topnav-right">
                <Link to="/settings/email" title="Email config">⚙ Email</Link>
                {auth.isAdmin() && <Link to="/admin/ai-config" title="Admin AI config">⚙ AI</Link>}
                {auth.isAdmin() && <Link to="/admin/search-config" title="Admin Search config">⚙ Search</Link>}
                <span className="topnav-user">{user.name}</span>
                <button onClick={() => { auth.clear(); nav('/login') }}>Logout</button>
            </div>
        </nav>
    )
}

export default function App() {
    return (
        <div className="app-root">
            <NavBar />
            <main className="app-main">
                <Routes>
                    <Route path="/login" element={<LoginPage />} />
                    <Route path="/subscribe/:trackingId" element={<SubscriptionPreferencePage />} />

                    <Route path="/" element={<Navigate to="/dashboard" replace />} />
                    <Route path="/dashboard" element={<RequireAuth><DashboardPage /></RequireAuth>} />
                    <Route path="/discover" element={<RequireAuth><DiscoverPage /></RequireAuth>} />
                    <Route path="/prospects" element={<RequireAuth><ProspectsPage /></RequireAuth>} />
                    <Route path="/prospects/:id" element={<RequireAuth><ProspectDetailPage /></RequireAuth>} />
                    <Route path="/leads" element={<RequireAuth><LeadsPage /></RequireAuth>} />
                    <Route path="/reports" element={<RequireAuth><ReportsPage /></RequireAuth>} />
                    <Route path="/ticklers" element={<RequireAuth><TicklersPage /></RequireAuth>} />
                    <Route path="/email-logs" element={<RequireAuth><EmailLogsPage /></RequireAuth>} />
                    <Route path="/settings/email" element={<RequireAuth><SettingsEmailPage /></RequireAuth>} />
                    <Route path="/admin/ai-config" element={<RequireAuth><AdminAIConfigPage /></RequireAuth>} />
                    <Route path="/admin/search-config" element={<RequireAuth><AdminSearchConfigPage /></RequireAuth>} />

                    <Route path="*" element={<div style={{ padding: 40 }}>Page not found</div>} />
                </Routes>
            </main>
        </div>
    )
}
